(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('AttendanceCounterService', AttendanceCounterService);

  AttendanceCounterService.$inject = ['$resource'];

  function AttendanceCounterService ($resource) {
    return $resource(apiUrl + '/attendance-counter/:id', { id: '@id' }, {
      callCommand: { url: apiUrl + '/attendance-counter/call-command', method: 'POST', params: {}, isArray: false }
    });
  }
})();
